export const ASSET_NAME = 'terms-of-service';

// Attorney Terms are local. Do not fetch Console stubs.
export const loadData = () => () => Promise.resolve();
